import { computed } from '@nuxtjs/composition-api';
// import { sharedRef } from '@vue-storefront/core';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import {
  CustomQuery
} from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const useDistributor = (id: string): any => {
  // Loads context used to call API endpoint
  const { set: setError } = useApiError();
  const context = useVSFContext();
  // console.log("useDistributorcontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `useDistributor-${id}`);
  const list = sharedRef(null, `useDistributorListOrder-${id}`);
  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useDistributor-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `useDistributor-error-${id}`);
  const listError = sharedRef({}, `useDistributorOrder-error-${id}`);
  const distributorList = async (params: CustomQuery) => {
    try {
      // setError({ code: 300, message: '没有代理商' });
      loading.value = true;
      const res = await context.$xbuy.api.distributorList(params);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value.load = null;
      } else {
        setError({ code: res.code, message: res.message });
        error.value.load = new Error(res.message);
      }
    } catch (err) {
      error.value.load = err;
    } finally {
      loading.value = false;
    }
  };
  const distributorAdd = async (params: CustomQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.distributorAdd(params);
      // context.useApiError.set(res);
      await distributorList({});
      if (res && res.code === 0) {
        error.value.load = null;
      } else {
        if (res.code === 9424) {
          return false;
        }
        setError({ code: res.code, message: res.message });
        error.value.load = new Error(res.message);
      }
    } catch (err) {
      error.value.load = err;
    } finally {
      loading.value = false;
    }
  };
  const distributorOrderList = async (params: CustomQuery) => {
    try {
      const res = await context.$xbuy.api.distributorOrderList(params);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        list.value = res.data;
        listError.value.load = null;
      } else {
        setError({ code: res.code, message: res.message });
        listError.value.load = new Error(res.message);
        list.value = null;
      }
    } catch (err) {
      listError.value.load = err;
      list.value = null;
    }
  };
  return {
    distributorAdd,
    distributorList,
    distributorOrderList,
    list: computed(() => list.value),
    listError: computed(() => listError.value),
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
